import api from "./Api";

class CstCClassTribService {
  GetCstCClassTrib(payload) {
    return api.get("/v1/cstCClassTrib/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCstCClassTrib(payload) {
    return api.post("/v1/cstCClassTrib/", payload).then((response) => {
      return response.data;
    });
  }

  PutCstCClassTrib(payload) {
    return api.put("/v1/cstCClassTrib/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCstCClassTrib(payload) {
    return api.delete("/v1/cstCClassTrib/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCstCClassTribOData(payload) {
    return api.get("/OData/CstCClassTrib" + payload).then((response) => {
      return response.data;
    });
  }

  AtualizarTabelaCstCClassTrib(payload) {
    return api
      .post("/v1/cstCClassTrib/AtualizarTabelaCstCClassTrib", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new CstCClassTribService();
